// @section 1 v5 AppShell — grid frame, top bar, sidebar, drawer.
// Wraps all routes. Children are rendered in the <main.v5-canvas> region. The
// mission-briefing drawer lives at this level so any descendent can open it
// via useDrawer().

import { ReactNode, useState } from 'react';
import { Drawer } from './Drawer';
import { DrawerProvider } from './DrawerContext';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

type Props = {
  onCapture: () => void;
  onQuickAction: () => void;
  onSignOut: () => void;
  children: ReactNode;
};

export function AppShell({ onCapture, onQuickAction, onSignOut, children }: Props) {
  // @block 1.1 Mobile nav drawer. On phones (<=820px, see v5.css §12) the
  // sidebar is off-canvas; the ☰ button toggles `nav-open` and tapping a nav
  // link or the backdrop closes it. No effect on desktop (sidebar stays in grid).
  const [navOpen, setNavOpen] = useState(false);
  return (
    <DrawerProvider>
      <div className={`v5-app${navOpen ? ' nav-open' : ''}`}>
        <TopBar onMenu={() => setNavOpen((v) => !v)} />
        <Sidebar
          onCapture={onCapture}
          onQuickAction={onQuickAction}
          onSignOut={onSignOut}
          onNavigate={() => setNavOpen(false)}
          envTag="Vertis Group · v5"
        />
        <main className="v5-canvas">{children}</main>
        <div className="v5-nav-backdrop" onClick={() => setNavOpen(false)} />
      </div>
      <Drawer />
    </DrawerProvider>
  );
}
